import React from "react";
import Footer from "../Footer/Footer";
import Navbars from "../Navbar/Navbar";
import ScrollToTop from "../ScrollTop";

export default function FairplayPolicy() {
  return (
    <div>
      <Navbars />
      <ScrollToTop />
      <div
        style={{
          backgroundColor: "#050810",
          marginTop: "55px",
          color: "white",
        }}
      >
        <div className="container">
          <div
            className="d-flex p-4"
            style={{
              justifyContent: "center",
              alignItems: "center",
              fontFamily: "NunitoBlack",
            }}
          >
            <p style={{ color: "#f9c130", fontSize: "30px" }}>
              Fairplay Policy
            </p>
          </div>
          <div style={{ fontSize: "17px", lineHeight: 2 }}>
            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              Wolfwin is an online gaming platform where the competitive spirit
              of India comes alive. We deeply believe in sportsmanship, fair
              play, transparency and integrity. We demand this of ourselves and
              our community on the Wolfwin app. Accordingly, our Fairplay Policy
              covers the below-mentioned aspects to guard the spirit of
              competition and responsible gameplay as the users compete against
              one another in various online skill-based casual games on the
              Wolfwin app:
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b>Real Players Only:</b>
              </span>
              We strive to ensure that we only have genuine users playing on the
              Wolfwin app. To facilitate this, we have strict policies and
              protocols to check any violation of our Fairplay Policy.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b>No Cheating Allowed:</b>
              </span>
              We do not allow hacking in any form, including using bugs,
              third-party tools or multiple accounts to access the Wolfwin app,
              and such behavior will lead to the user being banned from the
              Wolfwin app.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b> No Collusion Tolerated:</b>
              </span>
              The users participating in real money games and colluding with
              others will be banned from the Wolfwin app.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b>No Collusion Tolerated:</b>
              </span>
              Security &amp; Privacy Ensured: We use standard data security
              practices and tools to ensure the security and privacy of user
              data. All our systems are regularly tested using automated and
              manual processes for security.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b>Secure Payments:</b>
              </span>
              We work with a third-party payment gateway, Paytm (with
              authentication mechanism), to ensure the safety and security of
              all financial transactions. We do not store users&rsquo;
              credit/debit card details.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b> Instant Withdrawals:</b>
              </span>
              We have a seamless instant withdrawal process to ensure
              hassle-free withdrawal for users.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b> Game Fraud Detection:</b>
              </span>
              We have automated detection systems to identify fraudulent
              behaviour in games.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b> The users on the Wolfwin</b>
              </span>
              app are paired with other real users in real-time, depending on
              when they initiate the gameplay. They are matched with other real
              people who also initiate the gameplay for the same game.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b>Game Abandonment Upon Disconnection:</b>
              </span>
              Games disconnected due to poor internet connectivity will be
              declared abandoned, and users will lose the game. We advise users
              to check their internet connection before they start playing.
              Wolfwin will not be responsible for the internet connections of
              individual players.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b> Responsible Gameplay: </b>
              </span>
              We warn our users against participating in more than 150 games on
              a single day. We notify them in case their accrued losses exceed
              Rs. 1,00,000. We do not allow users below 18 years of age to play
              games on the Wolfwin app.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b> Compliant With Indian Laws:</b>
              </span>
              Wolfwin app is a skill-based platform and is offered in accordance
              with Indian laws. The games offered on the Wolfwin app are
              predominantly skill-based, where the element of skill is much more
              than the element of chance. There are no shortcuts or cheat codes
              for quick and easy wins.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b>Returns Dependant on Skill:</b>
              </span>
              The probability of return from playing games offered on the
              Wolfwin app is dependent on the skill being exhibited by a user.
              In other words, the returns are the same for each player who
              displays a certain degree of skill.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b>Swift &amp; Easy Communication:</b>
              </span>
              We have set up processes within the Wolfwin app to ensure that
              users can easily communicate with our customer support staff. We
              also ensure swift response timelines and complete support to the
              users.
            </p>

            <p style={{ textAlign: "justify", fontFamily: "Nunito" }}>
              <span style={{ fontSize: "20px", textDecoration: "underline" }}>
                <b>Note:</b>
              </span>
              If we determine, at our sole discretion, that a user has violated
              our Fair Play Policy, then we may take actions against such users
              as we deem fit, including but not limited to
              suspending/terminating their account on the Wolfwin app.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
